import React, { useState, useEffect } from "react";
import WeekCard from "./WeekCard";
import NavigationButtons from "./NavigationButtons";
import "../styles/scheduleStyles.css";

function Schedule() {
    const [matchesData, setMatchesData] = useState([]);
    const [currentWeekIndex, setCurrentWeekIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch("/api/matchesData.json")
            .then(response => response.json())
            .then(data => {
                setMatchesData(data.matchesData);
                const defaultWeekIndex = data.matchesData.findIndex(week => week.week === data.LAST_PLAYED_WEEK);
                setCurrentWeekIndex(defaultWeekIndex >= 0 ? defaultWeekIndex : 0);
                setLoading(false);
            })
            .catch(err => {
                setError("Unable to load schedule.");
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div>
            <NavigationButtons
                onPrev={() => setCurrentWeekIndex(currentWeekIndex - 1)}
                onNext={() => setCurrentWeekIndex(currentWeekIndex + 1)}
                disablePrev={currentWeekIndex === 0}
                disableNext={currentWeekIndex === matchesData.length - 1}
            />
            <WeekCard matches={matchesData[currentWeekIndex].matches} />
        </div>
    );
}

export default Schedule;
